import setActiveCompany from './setActiveCompany';

export default {
	setActiveCompany,
};
